import { Country } from 'constants/country';
import { defaultCountries } from 'constants/countryData';
import { errorMessageRequired } from 'constants/validation';
import { empty } from 'utils/helpers';
import { isCountry } from './countries';

export const validateRequired = <T extends object>(requiredFields: Array<string>, values?: T) => {
  if (!values) return {} as Record<string, string>;
  return requiredFields.reduce(
    (acc: Record<string, string>, field: string) =>
      empty(values[field as keyof T]) ? { ...acc, [field]: errorMessageRequired } : acc,
    {} as Record<string, string>
  );
};

export const validateEmail = (value: string) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(value);

export const validateConfirm = (value1: string, value2: string) => value1 === value2;

export const calculatePasswordStrength = (value: string) => {
  const hasLowercase = /[a-z]/.test(value);

  const hasUppercase = /[A-Z]/.test(value);

  const hasSymbol = !/^[A-Za-z0-9 ]+$/.test(value);

  const hasNumber = /\d/.test(value);

  const caseScore = +hasLowercase + +hasUppercase;

  const symbolNumberScore = caseScore === 2 ? +hasSymbol + +hasNumber : 0;

  return caseScore + symbolNumberScore;
};

export const validatePassword = (value: string) => {
  if (!value || value.length < 8) return 0;
  return calculatePasswordStrength(value);
};

export const validateLength = (value: string, length: number) => value.length === length;

export const validateEmailList = (value: string) => {
  if (/\s/.test(value)) return false;

  const emailArr = value.split(',');

  if (!emailArr || emailArr.length === 0) return false;

  return emailArr.every((email: string) => validateEmail(email));
};

export const validatePostalCode = (country: Country | string, value: string) => {
  if (!isCountry(country) || !defaultCountries.includes(country as Country)) return true;

  const regex = country === 'CA' ? /^([A-Z][0-9][A-Z])\s*([0-9][A-Z][0-9])$/ : /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/;

  return regex.test(value);
};
